import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "@tanstack/react-query";
import { useIonToast } from "@ionic/react";

import SettingsApi from "../../../../api/settings";
import { useAppStore } from "../../../../store/app";

const CompanyProfile = ({ refreshUser } : { refreshUser: Function }) => {
  const [companyName, setCompanyName] = React.useState("");
  const company = useAppStore((state) => state.user.company);

  const [present] = useIonToast();
  const intl = useIntl();

  const handleForm = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    return mutateUpdateSettings({
      name: companyName
    })
  };

  const {
    mutate: mutateUpdateSettings,
    isPending: isUpdating,
  } = useMutation({
    mutationFn: SettingsApi.updateSettings,
    onSuccess: async (data) => {
      if (data.ok) {
        await refreshUser();
        return present({
          message: intl.formatMessage({ id: "common.tryItLater" }),
          duration: 6000,
          color: "light",
          position: "top",
        });
      }
    },
    onError: () => {
      return present({
        message: intl.formatMessage({ id: "common.tryItLater" }),
        duration: 6000,
        color: "light",
        position: "top",
      });
    },
  });

  React.useEffect(() => {
    if (company && company.name) {
      setCompanyName(company?.name || "");
    }
  }, [company?.name])

  return (
    <div className="settings-presentation">
      <h4>
        <FormattedMessage id="settings.company" />
      </h4>
      <p className="color-step-700 fs-3">
        <FormattedMessage id="settings.company.desc" />
      </p>
      <hr />
      <form className="flex flex-column gap-1 mt-2" onSubmit={handleForm}>
        <label className="form-label">
          <FormattedMessage id="auth.register.company" />
        </label>
        <input
          type="text"
          className="form-control no-focus"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          autoComplete="off"
          autoCapitalize="off"
          required
          disabled={isUpdating}
        />
        <button
          className="btn btn-visito-primary mt-3 w-max ml-auto"
          disabled={isUpdating}
        >
          <FormattedMessage id="common.save" />
        </button>
      </form>
    </div>
  );
};

export default CompanyProfile;
